module.exports = __webpack_public_path__ + "assets/icon-2-cdfad25f.png";